module.exports = __webpack_public_path__ + "img/polygon-logo-switch-grey.89e69aee.svg";